import { styled } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ToReceiveCrossdockingPendingTab,
  ToReceiveCrossdockingIncompleteTab,
} from '../views';
import {
  useCrossdockingContext,
  useExternalSearchSync,
  useGetToReceiveCrossdockingOrders,
} from '../../application/hooks';

import { useExternalTotalCountSync } from '../../application/hooks';

const Blinking = styled(CircleIcon)`
  font-size: 10px;
  animation: blink 1s infinite;
  color: ${({ theme }) => theme.palette.secondary.dark};
  @keyframes blink {
    0%,
    100% {
      opacity: 0.2;
      transform: scale(0.9);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export default function useTabsItems({ setOpenBarcodeScanner }) {
  const { t } = useTranslation(['description']);

  const { filters: crossdockingFilters } = useCrossdockingContext();

  const { data: ordersPending, isSuccess: isSuccessPending } =
    useGetToReceiveCrossdockingOrders({
      ...crossdockingFilters,
    });
  const { data: ordersIncomplete, isSuccess: isSuccessIncomplete } =
    useGetToReceiveCrossdockingOrders({
      ...crossdockingFilters,
      status: 'incomplete',
    });

  const pendingCount = useMemo(
    () => ordersPending?.pages[0]?.data?.count || 0,
    [ordersPending]
  );
  const incompleteCount = useMemo(
    () => ordersIncomplete?.pages[0]?.data?.count || 0,
    [ordersIncomplete]
  );

  const totalCount = useMemo(() => {
    return (
      ordersIncomplete?.pages[0]?.data?.total_orders ||
      ordersPending?.pages[0]?.data?.total_orders
    );
  }, [ordersIncomplete?.pages, ordersPending?.pages]);

  useExternalTotalCountSync({
    isSuccessPending,
    isSuccessIncomplete,
    totalCount,
  });

  useExternalSearchSync();

  return useMemo(
    () => [
      {
        id: 'pending',
        label: (
          <span>
            {t('orders.crossdocking.tabs.pending')} (
            {isSuccessPending ? pendingCount : <Blinking />})
          </span>
        ),
        component: () => <ToReceiveCrossdockingPendingTab />,
        value: 0,
        showCount: false,
      },
      {
        id: 'incomplete',
        label: (
          <span>
            {t('orders.crossdocking.tabs.incomplete')} (
            {isSuccessIncomplete ? incompleteCount : <Blinking />})
          </span>
        ),
        component: () => <ToReceiveCrossdockingIncompleteTab />,
        value: 1,
        showCount: false,
      },
    ],
    [incompleteCount, isSuccessIncomplete, isSuccessPending, pendingCount, t]
  );
}
